<template>
    <div class="site-comp-tags" @click="change($event)">
        <span
            class="tag"
            v-for="item in data"
            :key="item[valueLabel]"
            v-html="item[valueLabel]"
            :class="{ active: val == item[valueKey] }"
            :data-id="item[valueKey]"
        ></span>
    </div>
</template>

<script>
const VALUE_KEY = 'value';
const VALUE_LABEL = 'label';
export default {
    emits: ['update'],
    data: function() {
        return {
            val: this.modelValue,
            valueKey: VALUE_KEY,
            valueLabel: VALUE_LABEL
        };
    },
    props: {
        data: Array,
        modelValue: [String, Number]
    },
    methods: {
        change(e) {
            if (!e.target.classList.contains('tag')) {
                return; 
            }
            let newVal = e.target.dataset.id;
            this.val =
                typeof this[VALUE_KEY] === 'number' ? Number(newVal) : newVal;
            this.$emit('update:modelValue', this.val);
        }
    }
};
</script>

<style lang="scss">
.site-comp-tags {
    overflow: auto;
    white-space: nowrap;
    margin-bottom: 23px;
    .tag {
        padding: 0 15px;
        height: 28px;
        display: inline-block;
        line-height: 28px;
        color: #a8a8a8;
        background-color: #f3f3f3;
        font-family: var(--font-medium);
        border-radius: 5px;
        &.active {
            font-family: var(--font-bold);
            color: #ff781d;
            background-color: rgba(255, 120, 29, 0.15);
        }
        & + .tag {
            margin-left: 15px;
        }
    }
}
</style>
